import { redirectLogin } from "api/authentication/helper";
import SecondaryBackButton from "components/BackButton/Secondary";
import SimpleLogo from "components/SimpleLogo";
import useLocalizedRoutes from "hooks/useLocalizedRoutes";
import { Entity } from "interfaces/entities";
import { Heading } from "iparque-components";
import React, {
  ChangeEvent,
  RefObject,
  useEffect,
  useRef,
  useState,
} from "react";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router-dom";
import { isInternetExplorer } from "utils/browser";
import { gaCategory, gaEvents } from "utils/googleAnalytics";
import OldBrowserWarning from "../OldBrowserWarning";
import EntityItem from "./EntityItem";
import {
  InnerContainer,
  StyledContentContainer,
  StyledFullPageContainer,
  StyledSearch,
} from "./styles";

export interface EntitiesState {
  entities: Array<Entity>;
  authToken: string;
}

const EntitiesPage: React.FC = () => {
  const { t } = useTranslation();
  const { state }: { state: EntitiesState | undefined } = useLocation();
  const listRef = useRef() as RefObject<HTMLDivElement>;
  const [search, setSearch] = useState("");
  const [filteredEntities, setFilteredEntities] = useState(
    state?.entities || []
  );
  const { getLanguageRoute } = useLocalizedRoutes();

  useEffect(() => {
    if (state?.entities.length === 1) {
      ReactGA.event({
        category: gaCategory,
        action: gaEvents.entityChosen,
      });

      redirectLogin(state.entities[0], state.authToken, { t });
    }
  }, [state, t]);

  const onSearchChangeHandler = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setSearch(value);
    setFilteredEntities(
      state?.entities.filter((entity) =>
        entity.name.toLowerCase().includes(value.trim().toLowerCase())
      ) || []
    );
  };

  if (!state?.entities.length) {
    return <Navigate to={getLanguageRoute("login")} />;
  }

  return (
    <StyledFullPageContainer>
      {isInternetExplorer && <OldBrowserWarning />}
      <SecondaryBackButton to={getLanguageRoute("login")} />
      <StyledContentContainer>
        <InnerContainer>
          <SimpleLogo />
          <Heading variant="h9" className="mb-30">
            {t("9264") /* Escolha a concessionária */}
          </Heading>
          <StyledSearch
            name="entities-search"
            className="mb-30"
            placeholder={t("4377") /* Pesquisa */}
            value={search}
            onChange={onSearchChangeHandler}
          />
          <div ref={listRef}>
            {filteredEntities.map((entity) => (
              <EntityItem
                key={entity.token}
                entity={entity}
                authToken={state.authToken}
                onClick={redirectLogin}
              />
            ))}
          </div>
        </InnerContainer>
      </StyledContentContainer>
    </StyledFullPageContainer>
  );
};

export default EntitiesPage;
